import { CheckCircleOutlined, HighlightOffOutlined } from '@mui/icons-material'
import { Grid, Skeleton, Typography } from '@mui/material'

import useStyles from '../../index.styles'

const NotificationPreference = ({ label, state }: { label: string; state: PreferenceStateType }) => {
  const classes = useStyles

  return (
    <Grid sx={classes.notificationPreference}>
      {state === 'on' && <CheckCircleOutlined sx={classes.notificationPreferenceOnIcon} aria-label={`${label} notifications are turned on`} />}
      {state === 'off' && <HighlightOffOutlined sx={classes.notificationPreferenceOffIcon} aria-label={`${label} notifications are turned off`} />}
      {state === 'loading' && <Skeleton variant="circular" width="24px" height="24px" />}
      <Typography variant="body2">{label}</Typography>
    </Grid>
  )
}

export default NotificationPreference
